import { createFileRoute, redirect } from '@tanstack/react-router';

import { getDefaultPeriod } from '@/features/contract-and-cost/period';

export const Route = createFileRoute(
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/software/$id/contract-and-cost/payment/$period',
      params: { id: params.id, period: getDefaultPeriod() },
    });
  },
});
